/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import Model from '@tripian/model';
import CloseIconButton from '../Button/Icons/CloseIconButton/CloseIconButton';
import ToggleSwitch from '../ToggleSwitch/ToggleSwitch';
import LanguageSelection from '../LanguageSelection/LanguageSelection';
import classes from './SideNavigation.scss';

enum MENUITEMS {
  TRIPS = 'TRIPS',
  USER = 'USER',
  SUPPORT = 'SUPPORT',
}

interface ISideNavigationMenuItem {
  header: string;
  title: string;
  onClick: () => void;
  hide?: boolean;
}

interface ISideNavigation {
  title: string;
  menuItems: ISideNavigationMenuItem[];
  open?: boolean;
  closed: () => void;
  showBbButton?: boolean;
  themeSwitchChecked: boolean;
  themeSwitchCheckedOnchange: (checked: boolean) => void;
  showThemeSwitch: boolean;
  languageOptions?: Model.LangCode[];
  selectedLanguage: string;
  onSelectedLanguage: (value: string) => void;
  t: (value: Model.TranslationKey) => string;
}

const SideNavigation: React.FC<ISideNavigation> = ({ title, menuItems, closed, open = false, showBbButton = false, themeSwitchChecked, themeSwitchCheckedOnchange, showThemeSwitch, languageOptions, selectedLanguage, onSelectedLanguage, t }) => {
  const overlayClicked = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    event.stopPropagation();
    closed();
  };

  const sidenavOverlayClasses = [classes.sidenavOverlay];
  const sidenavClasses = [classes.sidenav];
  if (open) {
    sidenavOverlayClasses.push(classes.sidenavOverlayOpen);
    sidenavClasses.push(classes.sidenavOpen);
  }

  const extraMenuItemsFiltered = menuItems.filter((menuItem) => !menuItem.hide && menuItem.header !== MENUITEMS.TRIPS && menuItem.header !== MENUITEMS.USER && menuItem.header !== MENUITEMS.SUPPORT);
  const extraMenuItems = extraMenuItemsFiltered.reduce((prev: Record<string, ISideNavigationMenuItem[]>, cur: ISideNavigationMenuItem) => {
    const newRecord = { ...prev };
    newRecord[cur.header] = newRecord[cur.header] || [];
    newRecord[cur.header].push(cur);
    return newRecord;
  }, {});

  return (
    <>
      <div className={sidenavOverlayClasses.join(' ')} onClick={overlayClicked} onKeyPress={() => {}} role="button" tabIndex={0}>
        {' '}
      </div>
      <div className={sidenavClasses.join(' ')}>
        <div className={classes.image}>
          {title !== ' ' ? <span className={classes.title}>{`${t('user.hi')}, ${title}`}</span> : null}

          <CloseIconButton
            className={classes.close}
            fill="#fff"
            clicked={() => {
              closed();
            }}
          />

          {showThemeSwitch && (
            <div className={classes.themeToggle}>
              <ToggleSwitch checked={themeSwitchChecked} optionLabels={[t('theme.dark'), t('theme.light')]} onChange={() => themeSwitchCheckedOnchange(themeSwitchChecked)} />
            </div>
          )}
        </div>

        <LanguageSelection languageOptions={languageOptions} selectedLanguage={selectedLanguage} onSelectedLanguage={onSelectedLanguage} />

        <ul className={`${classes.sidenavList} ${showBbButton ? classes.sideNavCustomHeight : ''}`}>
          {menuItems.some((menuItem) => !menuItem.hide && menuItem.header === MENUITEMS.TRIPS) && (
            <li>
              <h3 className="m4">{t('trips.title').toUpperCase()}</h3>
            </li>
          )}
          {menuItems
            .filter((menuItem) => !menuItem.hide && menuItem.header === MENUITEMS.TRIPS)
            .map((menuItem) => (
              <li key={menuItem.title}>
                <button
                  className={classes.button}
                  key={menuItem.title}
                  type="button"
                  onClick={() => {
                    closed();
                    menuItem.onClick();
                  }}
                >
                  {menuItem.title}
                </button>
              </li>
            ))}

          {Object.entries(extraMenuItems).map((record) => {
            const header = record[0];
            const items = record[1];

            return (
              <React.Fragment key={`header_${header}`}>
                <li>
                  <h3 className="m4">{header}</h3>
                </li>
                {items.map((menuItem) => (
                  <li key={menuItem.title}>
                    <button
                      className={classes.button}
                      key={menuItem.title}
                      type="button"
                      onClick={() => {
                        closed();
                        menuItem.onClick();
                      }}
                    >
                      {menuItem.title}
                    </button>
                  </li>
                ))}
              </React.Fragment>
            );
          })}

          <li>
            <h3 className="m4">{t('user.title').toUpperCase()}</h3>
          </li>
          {menuItems
            .filter((menuItem) => !menuItem.hide && menuItem.header === MENUITEMS.USER)
            .map((menuItem) => (
              <li key={menuItem.title}>
                <button
                  className={classes.button}
                  key={menuItem.title}
                  type="button"
                  onClick={() => {
                    closed();
                    menuItem.onClick();
                  }}
                >
                  {menuItem.title}
                </button>
              </li>
            ))}
          <li>
            <h3 className="m4">{t('support.title').toUpperCase()}</h3>
          </li>
          {/* <li>
            <div className={classes.links}>
              <a target="_blank" href="https://tripian.zendesk.com/hc/en-us">
                Help Desk
              </a>
            </div>
          </li>
          <li>
            <div className={classes.links}>
              <a target="_blank" href="https://tripian.zendesk.com/hc/en-us/requests/new">
                Contact Support
              </a>
            </div>
          </li> */}

          {menuItems
            .filter((menuItem) => !menuItem.hide && menuItem.header === MENUITEMS.SUPPORT)
            .map((menuItem) => (
              <li key={menuItem.title}>
                <button
                  className={classes.button}
                  key={menuItem.title}
                  type="button"
                  onClick={() => {
                    // if (menuItem.title === 'Feedback') setShowFeedbackModal(true);
                    closed();
                    menuItem.onClick();
                  }}
                >
                  {menuItem.title}
                </button>
              </li>
            ))}
        </ul>

        {showBbButton && (
          <a className={classes.bbHomeLink} href="https://bookbarbados.com/" target="_blank">
            <div className={classes.bbHomeLinkImg} />
          </a>
        )}
      </div>
    </>
  );
};

export default SideNavigation;
